import { SVGProps } from 'react';

function Info(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 12H10a1 1 0 0 1-1-1V8.5a.5.5 0 0 0-.5-.5H8M8.75 5.5a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5v0"
        stroke="#7E849A"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
        stroke="#7E849A"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Info.defaultProps = {
  role: 'graphics-document',
};

export default Info;
